import React from 'react';
import { appPlatformFromOsName, compareAppVersions, type AppPlatform } from '@shared/app-version';

export type CurrentAppVersion = { platform: AppPlatform; recommendedVersion: string };

export function OperatorAppVersion({ installed, osName, currentVersions }: {
  installed?: string | null;
  osName?: string | null;
  currentVersions?: CurrentAppVersion[];
}) {
  const platform = appPlatformFromOsName(osName);
  const current = currentVersions?.find(version => version.platform === platform)?.recommendedVersion;
  const comparison = compareAppVersions(installed, current);
  const status = comparison === -1 ? 'Update available' : comparison === 0 ? 'Up to date' : null;
  return <p className="text-xs text-muted-foreground">
    App installed: {installed || 'Not reported'} · {current ? `Current: ${current}` :
      currentVersions === undefined ? 'Current version unavailable' :
      !platform ? 'Phone type not reported' : 'Current version not set'}
    {status && <> · {status}</>}
  </p>;
}
